import 'css-chunksrc/client/common/filterMenu/styles.scss';export default {
  "filterMenu": "_filterMenu_1di0w_1",
  "root": "_root_1di0w_12",
  "search": "_search_1di0w_18",
  "list": "_list_1di0w_22"
};